import { IBusiness } from '@/coreDomainsModule/entities/businessBase';
import { IUnmanagedBusiness, ImportFileType } from '@/coreDomainsModule/entities/unmanagedBusiness';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { i18n } from '@/i18n';

/**
 *　未管理取引サービス
 */
export class UnmanagedBusinessService {
  static t = i18n.t;
  /**
   * 管理取引と未管理取引を比較してパラメータが完全一致するかどうかを返す
   * @param unmanagedBusiness - 未管理取引
   * @param business - 管理取引
   */
  public static equalsBusiness(unmanagedBusiness: IUnmanagedBusiness, business: IBusiness): boolean {
    // 共通条件
    const isCommonFieldsEqual =
      business.supplierName == unmanagedBusiness.supplierName &&
      business.businessNumber == unmanagedBusiness.businessNumber &&
      business.businessName == unmanagedBusiness.businessName &&
      business.package == unmanagedBusiness.package &&
      business.warehouse == unmanagedBusiness.warehouse;

    // 集計行用の条件
    const isAggregateRowEqual =
      this.isAggregateRow(unmanagedBusiness.importFileType) &&
      business.customerName == unmanagedBusiness.customerName &&
      business.salesDestinationName == unmanagedBusiness.salesDestinationName;

    // 条件の組み合わせで判定
    return isCommonFieldsEqual && (!this.isAggregateRow(unmanagedBusiness.importFileType) || isAggregateRowEqual);
  }

  /**
   * ImportFileTypeから集計行かどうかを返す
   * @param importFileType - 未管理取引のファイルタイプ
   */
  public static isAggregateRow(importFileType: ImportFileType): boolean {
    return importFileType === ImportFileType.Announce || importFileType === ImportFileType.SalesResult;
  }

  /**
   * 取引の集合の中に指定の未管理取引の集計取引が含まれているかどうかを返す
   * 集計取引とは、supplierName, businessNumber, businessName, package, warehouseが全て一致している取引のこと
   * @param unmanagedBusiness - 未管理取引
   * @param businesses - 取引の集合
   */
  public static isIncludeAggregateRow(unmanagedBusiness: IUnmanagedBusiness, businesses: IBusiness[]): boolean {
    return businesses.some((business) => {
      return (
        business.supplierName == unmanagedBusiness.supplierName &&
        business.businessNumber == unmanagedBusiness.businessNumber &&
        business.businessName == unmanagedBusiness.businessName &&
        business.package == unmanagedBusiness.package &&
        business.warehouse == unmanagedBusiness.warehouse
      );
    });
  }

  /**
   * リードタイム単位と標準在庫指数の単位をシステムの単位に変換する
   * @param unit - 単位
   */
  public static convertUnitToSystemUnit(unit: string): string {
    switch (unit) {
      case this.t('取引登録モーダル選択肢:単位:日'):
        return 'day';
      case this.t('取引登録モーダル選択肢:単位:週'):
        return 'week';
      case this.t('取引登録モーダル選択肢:単位:月'):
        return 'month';
      default:
        console.error('不明な単位が指定されました');
        return unit;
    }
  }

  /**
   * リードタイム単位と標準在庫指数のシステム単位を表示用の単位に変換する
   * @param unit - システム単位
   */
  public static convertSystemUnitToDisplayUnit(unit: string): string {
    switch (unit) {
      case 'days':
      case 'day':
        return this.t('取引登録モーダル選択肢:単位:日');
      case 'week':
        return this.t('取引登録モーダル選択肢:単位:週');
      case 'month':
        return this.t('取引登録モーダル選択肢:単位:月');
      default:
        console.error('不明な単位が指定されました');
        return unit;
    }
  }
}
